import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import api from '../utils/api';
import { rememberAdSource } from '../utils/adSource';
import Home from './Home';

// /go/<slug>: the link given to an advertiser (e.g. /go/yidstatus).
// The address stays as is and the home page is shown right here, while the
// click is recorded in the background (once per browser tab, so reloads
// don't add clicks). Counted in the browser, so link previews and crawlers
// that don't run JavaScript don't count. A link made for another page
// (?to=/path) forwards there instead.
const SLUG_RE = /^[a-z0-9][a-z0-9-]{0,39}$/;

export default function GoLink() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const clean = String(slug || '').toLowerCase();
  const to = params.get('to') || '/';
  // Site paths only (no open redirect).
  const dest = /^\/(?!\/)[^\s]*$/.test(to) ? to : '/';

  useEffect(() => {
    if (SLUG_RE.test(clean)) {
      rememberAdSource(clean);
      const key = `itsasimcha_go_${clean}`;
      let seen = false;
      try { seen = sessionStorage.getItem(key) === '1'; sessionStorage.setItem(key, '1'); } catch (_) { /* private mode */ }
      if (!seen) api.post('/links/click', { slug: clean, referrer: document.referrer || '' }).catch(() => {});
    }
    // Passive effect (not layout): the router is listening by now, so the
    // page really changes along with the address.
    if (dest !== '/') navigate(dest, { replace: true });
  }, [clean, dest, navigate]);

  return dest === '/' ? <Home /> : null;
}
